import { Recording } from '../../recordings/state';

export enum SongStatus {
  REQUESTED = 'REQUESTED',
  LICENSED = 'LICENSED',
}

export interface DropSong {
  song: Recording | Recording[] | any;
  projectId: number;
  currentIndex: number;
  previousIndex: number;
}

export interface ProjectsModeDropSong {
  songs: Recording[];
  projectId: number;
  songCount: number;
}

interface SigningInformation {
  signing: string;
  control: string;
  admin: string;
  subpub: boolean;
  multideal: boolean;
  syncOwn: number;
  collect: number;
  mechOwn?: number;
}

interface PublisherRights {
  affiliateName: string;
  societyAbbreviation: string;
  role: string;
  syncPercentOwn: number;
  collect: number;
  mechPercentOwn?: number;
}

export interface WritersRights {
  writerName: string;
  writerPercentControl: number;
  role: string;
  wcmControl: boolean;
  syncPercentOwn: number;
  collect: number;
  publisherRights: PublisherRights[];
  mechPercentOwn?: number;
}

interface SummarizationInfo {
  syncPercentOwn: number;
  collect: number;
  mechPercentOwn?: number;
}

export interface SongRights {
  signingInformation: SigningInformation[];
  writersRights: WritersRights[];
  summarizationInfo: SummarizationInfo;
}

export interface RightsCreditsInfo {
  title?: string;
  adminLines?: string | string[];
  creatorLine?: string;
  creatorLastName?: string;
  owningPublisher?: string;
  wordsAndMusicLine?: string;
  collectingPublisher?: string;
  copyrightAndOwningPublisher?: string;
  collectingPublisherMechanicalRights?: string;
}

export interface SongRightsCredits {
  [key: string]: RightsCreditsInfo | RightsCreditsInfo[];
}

export interface SongApprovalItem {
  syncUsageCategory: string;
  preApproved: string;
  noApprovalRequired: string;
  restricted: string;
  reserved: string;
}

export interface SongApprovalContact {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

export interface SongApprovals {
  approvalsRestrictions: SongApprovalItem[];
  contacts: SongApprovalContact[];
  dealNumberAndParties: string;
}

export interface FormattedSongRightsCredits {
  title: string;
  content: string[];
}
